import { Component, OnInit, Input } from '@angular/core';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-cand-evaluate',
  templateUrl: './cand-evaluate.component.html',
  styleUrls: ['./cand-evaluate.component.scss']
})
export class CandEvaluateComponent implements OnInit {

  @Input() candData: any;
  constructor(public globals: Globals,public translate: TranslateService) { }

  ngOnInit(): void {
  }

  checkDataExist() {
    console.log(this.candData);
    return (typeof this.candData === 'object' && this.candData !== null)
  }
}
